export default __webpack_public_path__ + "static/media/COAT.e40f2f2df5795394f70df58105407fd1.webp";